import { render } from "./NavBar.vue?vue&type=template&id=4be06340"
const script = {}

import exportComponent from "/mnt/extra-storage/raiseloans/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__